import Partition from "molecules/partition";
import React from "react";

const kmp = [
  {
    name: "Mr. Amandeep Panwar",
    // nature: "Non-Executive Independent Director",
    designation: "Chairman and Managing Director",
  },
  {
    name: "Mr. Rishabh Choudhary",
    // nature: "Non-Executive Independent Director",
    designation: "Whole Time Director",
  },
  {
    name: "Mr. Ved Prakash Goel",
    // nature: "Chairman and Managing Director",
    designation: "Chief Financial Officer",
  },
  {
    name: "Ms. Aakansha Singh",
    // nature: "Chairman and Managing Director",
    designation: "Company Secretary and Compliance Officer",
  },
];

const smp = [
  {
    name: "Mr. Vimal Kumar Verma",
    nature: "Non-Executive Non-Independent Director",
    designation: "SMP-Farmer Success Management",
  }
];


const CommitteeTable = ({ title , members } : {title  :string, members : any[]}) => (
  <div className="mt-6 mb-4 border border-green rounded-lg overflow-hidden shadow-sm">
    <h3 className="bg-green text-lg font-semibold text-white uppercase px-6 py-3 border-b border-gray-300">
      {title}
    </h3>
    <div className="overflow-x-auto">
    <table className="min-w-full table-fixed text-left text-md text-black">
      <thead className="bg-green-100 text-green-900">
        <tr>
          <th className="w-1/2 px-6 py-2">Name</th>
          <th className="w-1/2 px-6 py-2">Designation</th>
        </tr>
      </thead>
      <tbody>
        {members.map((member: any, idx: number) => (
          <tr key={idx}>
            <td className="w-1/2 px-6 py-3">{member.name}</td>
            <td className="w-1/2 px-6 py-3">{member.designation}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  </div> 
);

export default function KMP () {
  return (
    <>
    <div className="bg-gradient-to-r from-[#5D6A5D] to-[#193C34] w-full h-[64px] md:h-[80px] xl:h-[100px] 2xl:h-[90px]"></div>
    <section  className="bg-cream3 relative">
      
      <div className="p-6 max-w-5xl mx-auto text-[#101828]">
        <Partition color="dark" text="Details of KMP and SMP" />
      
        <CommitteeTable title="Key Managerial Personnel" members={kmp} />
        <CommitteeTable title="Senior Managerial Personnel" members={smp} />
      </div>
    </section>
    </>
  );
};